@reference "~/styles.css";

@layer components {
	.input {
		@apply w-full flex items-center rounded-sm border text-grey-800 cursor-text outline-hidden appearance-none motion-safe:transition-colors bg-white;
		@apply placeholder:text-grey-600;
		@apply read-only:bg-grey-100 read-only:text-grey-500 read-only:border-grey-400! read-only:placeholder:text-grey-400;
		@apply aria-disabled:cursor-not-allowed;
		@apply aria-busy:cursor-wait;
		@apply focus-visible:ring-2;

		/* Make the number input arrows appear nicer, inspired by https://daisyui.com/components/input/ */
		&[type="number"]::-webkit-inner-spin-button {
			@apply -my-2 -me-3;
		}

		& input {
			@apply flex appearance-none bg-transparent size-full border-none outline-hidden;
		}
	}

	/* VARIANTS */

	.neutral {
		@apply border-grey-400 ring-primary-500/30 hover:border-primary-500 focus-visible:border-primary-500;
	}

	.error {
		@apply border-red-500 ring-red-500/30;
	}

	/* SIZE */

	.sm {
		@apply h-6.5 px-2 text-xs;
	}

	.md {
		@apply h-8 px-3 text-13;
	}

	.lg {
		@apply h-10 px-4 text-sm;
	}

	/* EYE BUTTON */

	.eyeButton {
		:where(.input.sm) & {
			@apply -mx-1;
		}

		:where(.input.md) & {
			@apply -mx-1.5;
		}

		:where(.input.lg) & {
			@apply -mx-2;
		}
	}
}
